import { useEmployeeDisplayData } from 'domain/shared/employee';
import ContractCountryBadge from 'domain/shared/employee/badges/ContractCountryBadge';
import ContractorBadge from 'domain/shared/employee/badges/ContractorBadge';
import { FieldProps, useFieldHelper } from 'framework/ui/field';

const TeamMemberContractBadges = ({ source }: Pick<FieldProps, 'source'>) => {
  const { getValue } = useFieldHelper({ source });
  const employeeAlias = getValue();
  const employeeData = useEmployeeDisplayData(employeeAlias);

  if (!employeeData?.isContractor) return null;

  return (
    <>
      <ContractorBadge id={`contractor-${employeeAlias}`} className="" sx={{ ml: 0 }} />

      {employeeData?.contractCountry ? (
        <ContractCountryBadge
          id={`contract-country-${employeeAlias}`}
          sx={{ ml: 0 }}
          text={employeeData.contractCountry}
        />
      ) : null}
    </>
  );
};

export default TeamMemberContractBadges;
